import { Card, CardMedia } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { cn } from 'utils/styles';
import { getIcon, getImageProfile } from '../utils/galleryUtils';

function ImageCard({ image, onClick, store }) {
  const model = image.model;
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(
    image.thumbnails?.large ||
      image.thumbnails?.medium ||
      image.thumbnails?.small ||
      image.url
  );

  useEffect(() => {
    const highResImage = new Image();
    highResImage.src = image.url;
    highResImage.onload = () => {
      setCurrentSrc(image.url);
      setIsLoaded(true);
    };
  }, [image.url]);

  return (
    <Card
      className="scale-100 transition-all duration-300 hover:scale-105"
      sx={{
        boxShadow: 3,
        borderRadius: 3,
        cursor: 'pointer',
        bgcolor: 'background.paper',
        p: 0,
        m: 0,
      }}
      onClick={() => onClick(image)}
    >
      <CardMedia
        component="img"
        image={currentSrc}
        alt={image.type}
        sx={{
          position: 'relative',
          width: '100%',
          transition: 'filter 0.3s ease-in-out',
          filter: isLoaded ? 'none' : 'blur(10px)',
        }}
      />
      <div
        className={cn(
          'w-full absolute p-2 bottom-0 right-0 flex items-center gap-1',
          {
            'bg-gradient-to-t from-umbra via-raisin-black/70 to-transparent':
              store.profile._id !== image.creator._id,
          }
        )}
      >
        <div
          className={`flex items-center gap-1 font-figtree font-bold text-xs text-white uppercase px-[6px] py-[3px] bg-${
            model.color ? `[${model.color}]` : 'nue-blue'
          } rounded-lg`}
        >
          {getIcon(model)}
          <div>{model.abbreviation}</div>
        </div>
        {store.profile._id !== image.creator._id && getImageProfile(image)}
      </div>
    </Card>
  );
}

export default memo(ImageCard, (prevProps, nextProps) => {
  return prevProps.image._id === nextProps.image._id;
});
